const cancelUploadMealPopUpTranslations = {
  title: "رفض تحميل الوجبة",
  description: "هل أنت متأكد من أنك تريد رفض تحميل وجبتك",
  actionButtons: {
    cancel: "إلغاء",
    submit: "نعم متاكد",
  },
};

export default cancelUploadMealPopUpTranslations;
